import CloseIcon from '@mui/icons-material/Close';
import { CircularProgress, Grid } from '@mui/material';
import { DOWNLOAD_FILE } from 'framework/base/constants/aryRestCommands';
import useAryGetData, {
  aryGetDataExpectTypes
} from 'framework/base/hooks/useAryGetData';
import useLayoutTypeContext from 'framework/base/hooks/useLayoutTypeContext';
import React, { useEffect } from 'react';
import { imageAddressPrefix } from 'spec';
import ActionButtons from './ActionButtons';
import { DownloadIcon, DownloadIconWrapper } from './StyledComponents';
// TODO: use theme for colors
export default function ShowImgPreview({
  image,
  onClose,
  preview,
  previews,
  files,
  prevFiles,
  propsFileIds,
  removedFileIds,
  handleRemovedFileIds,
  onChange,
  setPreviews,
  setPrevFiles,
  handleSavedFileIds,
  hideDeleteIcon,
  closeShowPreviewAfterRemoveFile,
  onDownloadImage,
  imgHeight,
  imgWidth,
  handleSetDisabledDropzone,
  ...props
}) {
  const layoutType = useLayoutTypeContext();
  const [downloadFile, { loading: downloadFileLoading }] = useAryGetData(
    DOWNLOAD_FILE,
    {
      expect: aryGetDataExpectTypes.file
    }
  );
  const downloadImage = (fileId) => {
    downloadFile([{ key: 'fileId', value: fileId }]).then(
      (downloadFileData) => {
        onDownloadImage(downloadFileData);
      }
    );
  };
  useEffect(() => {
    if (image.downloadImgOnloadPreview && !image.imgSrc) {
      downloadImage(image.fileId);
    }
  }, []);
  useEffect(() => {
    const escPress = (e) => {
      if (e.code === 'Escape') {
        onClose();
      }
    };
    document.addEventListener('keyup', escPress);
    return () => {
      document.removeEventListener('keyup', escPress);
    };
  }, []);
  return (
    <Grid
      container
      height="100%"
      gap={1}
      onClick={(e) => e.stopPropagation()}
      {...props}
    >
      {image.downloaded && (
        <Grid
          item
          display="flex"
          xs={12}
          justifyContent="space-between"
          padding="1.5rem 1.75rem 0 1.75rem"
        >
          <ActionButtons
            preview={preview}
            previews={previews}
            files={files}
            prevFiles={prevFiles}
            propsFileIds={propsFileIds}
            removedFileIds={removedFileIds}
            handleRemovedFileIds={handleRemovedFileIds}
            onChange={onChange}
            setPreviews={setPreviews}
            setPrevFiles={setPrevFiles}
            handleSavedFileIds={handleSavedFileIds}
            closeShowPreviewAfterRemoveFile={closeShowPreviewAfterRemoveFile}
            hideDeleteIcon={hideDeleteIcon}
            handleSetDisabledDropzone={handleSetDisabledDropzone}
            iconSx={{ height: 'fit-content' }}
            style={{ alignItems: 'unset' }}
            iconSize="large"
          />
          <Grid item onClick={() => onClose()} sx={{ cursor: 'pointer' }}>
            <CloseIcon
              fontSize={layoutType === 'mobile' ? 'large' : ''}
              style={{ color: '#fff' }}
            />
          </Grid>
        </Grid>
      )}
      <Grid
        item
        display="flex"
        justifyContent="center"
        alignItems="start"
        width="100%"
        height="100%"
      >
        {image.imgSrc ? (
          <Grid
            container
            alignItems="center"
            gap=".5rem"
            justifyContent="center"
            width="90vw"
            height="90vh"
          >
            <img
              src={
                image.imgSrc === 'pdf' || image.filePreview === 'pdf'
                  ? `${imageAddressPrefix}static/img/icons/pdfIcon.png`
                  : image.imgSrc === 'docx'
                  ? `${imageAddressPrefix}static/img/icons/docxIcon.png`
                  : image.imgSrc === 'xlsx'
                  ? `${imageAddressPrefix}static/img/icons/xlsxIcon.png`
                  : image.imgSrc
              }
              width={imgWidth || '100%'}
              height={imgHeight || '100%'}
              alt="file preview"
            />
          </Grid>
        ) : downloadFileLoading ? (
          <Grid
            container
            height="100%"
            alignItems="center"
            justifyContent="center"
          >
            <CircularProgress size={50} />
          </Grid>
        ) : (
          !image.downloadImgOnloadPreview && (
            <Grid
              container
              height="100%"
              justifyContent="center"
              alignItems="center"
            >
              <DownloadIconWrapper
                onMouseUp={() => {
                  downloadImage(preview.fileId);
                }}
              >
                <DownloadIcon />
              </DownloadIconWrapper>
            </Grid>
          )
        )}
      </Grid>
    </Grid>
  );
}
